export class ArrayHelper {
    //This method checks if an array contains a value in a diffrent array.
    public static ArrayOneHasValueFromArrayTwo(arrayOne: Array<number | string>, arrayTwo: Array<number | string>): boolean {
        return arrayOne.some(value => arrayTwo.indexOf(value) >= 0);
    }
}
